export const LOGO_URL = "https://customer-assets.emergentagent.com/job_ruido-client-manager/artifacts/mrncf27a_blendBoard%20-%202026-04-12T151629.465.jpg";

export const VIDEO_THUMBNAILS = [
  "https://static.prod-images.emergentagent.com/jobs/6c773830-abf0-4b87-a3f1-775fc3702e56/images/c400cd47d245a6b03b0392846e915b0c969138e6b0d2057b9fd1d5d4e8ddfedb.png",
  "https://images.unsplash.com/photo-1597951562566-a1e7d9f64145?w=800",
  "https://images.unsplash.com/photo-1700662398558-2345fde2530e?w=800"
];

export const AVATARS = [
  "https://images.unsplash.com/photo-1769636929231-3cd7f853d038?w=200",
  "https://images.unsplash.com/photo-1765776830139-72b2184dae5a?w=200",
  "https://images.unsplash.com/photo-1758534063829-a72058381e21?w=200"
];

export const STATUS_CONFIG = {
  new: { label: 'New', clientLabel: 'New', textClass: 'text-gray-400' },
  received: { label: 'Received', clientLabel: 'Received', textClass: 'text-gray-500' },
  in_production: { label: 'In Production', clientLabel: 'In Production', textClass: 'text-gray-500' },
  ready: { label: 'Ready', clientLabel: 'Ready', textClass: 'text-emerald-600' },
  delivered: { label: 'Delivered', clientLabel: 'Delivered', textClass: 'text-emerald-600' },
  revision_requested: { label: 'Revision Requested', clientLabel: 'In Revision', textClass: 'text-amber-600' }
};

export const MOCK_BRANDS = [
  {
    id: 'brand-1',
    name: 'La Boqueria',
    initials: 'LB',
    color: '#D4A574',
    description: 'Premium Mediterranean restaurant & tapas bar',
    colors: ['#D4A574', '#2C1810', '#F5E6D3'],
    assets: [
      { id: 'a1', name: 'Main Logo.svg', type: 'image' },
      { id: 'a2', name: 'Brand Guide.pdf', type: 'document' },
      { id: 'a3', name: 'Menu Photos.zip', type: 'archive' }
    ]
  },
  {
    id: 'brand-2',
    name: 'MODA Studio',
    initials: 'MS',
    color: '#E8B4B8',
    description: 'Contemporary fashion brand for modern women',
    colors: ['#E8B4B8', '#1A1A2E', '#FAFAFA'],
    assets: [
      { id: 'a4', name: 'Logo Pack.zip', type: 'archive' },
      { id: 'a5', name: 'Lookbook 2025.pdf', type: 'document' }
    ]
  },
  {
    id: 'brand-3',
    name: 'NauticPro',
    initials: 'NP',
    color: '#4A90D9',
    description: 'Premium nautical upholstery & marine interiors',
    colors: ['#4A90D9', '#0D2137', '#C8DDE8'],
    assets: [
      { id: 'a6', name: 'NauticPro Logo.png', type: 'image' },
      { id: 'a7', name: 'Product Catalog.pdf', type: 'document' },
      { id: 'a8', name: 'Workshop Photos.zip', type: 'archive' }
    ]
  }
];

const hoursAgo = (h) => new Date(Date.now() - h * 3600000).toISOString();
const hoursFromNow = (h) => new Date(Date.now() + h * 3600000).toISOString();

export const MOCK_PROJECTS = [
  {
    id: 'proj-1',
    name: 'Restaurant Promo Video',
    client: { name: 'Carlos Mendoza', avatar: AVATARS[0] },
    brandId: 'brand-1',
    status: 'in_production',
    videoType: 'Promotional',
    duration: '60 seconds',
    style: 'Cinematic, warm tones',
    description: 'A promotional video showcasing the restaurant atmosphere, signature dishes, and dining experience.',
    createdAt: hoursAgo(48),
    deliveryDeadline: hoursFromNow(24),
    hasNewUpdate: false,
    qualityControl: null,
    delivery: null,
    internalNotes: 'Client wants warm, Mediterranean feel. Focus on food close-ups and ambient lighting.',
    messages: [
      { id: 'msg-1-1', type: 'system', content: 'Welcome to your new project! Tell us about the video you need.', sender: 'system', timestamp: hoursAgo(48) },
      { id: 'msg-1-2', type: 'user', content: 'I need a promotional video for our restaurant La Boqueria. We want to show the atmosphere, our signature dishes, and the overall dining experience.', sender: 'user', timestamp: hoursAgo(47.5) },
      { id: 'msg-1-3', type: 'system', content: "Great! We've set up your project. What duration works best for you?", sender: 'system', timestamp: hoursAgo(47), actions: [{ label: '30s', value: '30 seconds' }, { label: '60s', value: '60 seconds' }, { label: '90s', value: '90 seconds' }, { label: '2min', value: '2 minutes' }] },
      { id: 'msg-1-4', type: 'user', content: '60 seconds would be perfect.', sender: 'user', timestamp: hoursAgo(46.5) },
      { id: 'msg-1-5', type: 'user', content: 'Here are some reference photos from our restaurant.', sender: 'user', timestamp: hoursAgo(46), files: [{ name: 'restaurant-interior.jpg', type: 'image', size: '2.4 MB' }, { name: 'signature-dish.jpg', type: 'image', size: '1.8 MB' }, { name: 'terrace-view.jpg', type: 'image', size: '3.1 MB' }] },
      { id: 'msg-1-6', type: 'system', content: 'Beautiful references! Your project has been confirmed and is now in production. Track progress here.', sender: 'system', timestamp: hoursAgo(45) },
      { id: 'msg-1-7', type: 'status_update', content: 'Your project is now in production.', sender: 'system', timestamp: hoursAgo(20), newStatus: 'in_production' },
      { id: 'msg-1-8', type: 'team', content: "Hi Carlos! We're making great progress on your video. The warm Mediterranean color grading is looking amazing. We'll have a preview ready soon.", sender: 'Ana (Production)', timestamp: hoursAgo(8) }
    ]
  },
  {
    id: 'proj-2',
    name: 'Clothing Brand Lookbook',
    client: { name: 'Sofia Rivera', avatar: AVATARS[1] },
    brandId: 'brand-2',
    status: 'received',
    videoType: 'Lookbook / Fashion',
    duration: '90 seconds',
    style: 'Modern, editorial',
    description: 'Fashion lookbook video for the new spring/summer collection.',
    createdAt: hoursAgo(12),
    deliveryDeadline: hoursFromNow(60),
    hasNewUpdate: true,
    qualityControl: null,
    delivery: null,
    internalNotes: '',
    messages: [
      { id: 'msg-2-1', type: 'system', content: 'Welcome to your new project! Tell us about the video you need.', sender: 'system', timestamp: hoursAgo(12) },
      { id: 'msg-2-2', type: 'user', content: 'We need a lookbook video for our new spring/summer collection. Think editorial, modern, with a lot of movement and energy.', sender: 'user', timestamp: hoursAgo(11.5) },
      { id: 'msg-2-3', type: 'user', content: "Here's our brand kit and some mood board references.", sender: 'user', timestamp: hoursAgo(11), files: [{ name: 'MODA-brand-kit.pdf', type: 'document', size: '5.2 MB' }, { name: 'moodboard-ss25.jpg', type: 'image', size: '4.1 MB' }, { name: 'reference-video.mp4', type: 'video', size: '28.5 MB' }] },
      { id: 'msg-2-4', type: 'team', content: "Hi Sofia! Thanks for the detailed brief. We're reviewing everything now and will confirm the production plan shortly. The mood board looks fantastic!", sender: 'Marco (Director)', timestamp: hoursAgo(6) }
    ]
  },
  {
    id: 'proj-3',
    name: 'Nautical Upholstery Showcase',
    client: { name: 'Roberto Vega', avatar: AVATARS[2] },
    brandId: 'brand-3',
    status: 'in_production',
    videoType: 'Product Showcase',
    duration: '45 seconds',
    style: 'Clean, professional, maritime',
    description: 'Product showcase video highlighting craftsmanship and premium materials for marine interiors.',
    createdAt: hoursAgo(96),
    deliveryDeadline: hoursFromNow(6),
    hasNewUpdate: true,
    qualityControl: null,
    delivery: null,
    internalNotes: 'Client is very detail-oriented. Make sure fabric textures are sharp.',
    messages: [
      { id: 'msg-3-1', type: 'system', content: 'Welcome to your new project! Tell us about the video you need.', sender: 'system', timestamp: hoursAgo(96) },
      { id: 'msg-3-2', type: 'user', content: 'I need a product showcase video for NauticPro. We want to highlight our craftsmanship and the premium materials we use for marine interiors and yacht upholstery.', sender: 'user', timestamp: hoursAgo(95) },
      { id: 'msg-3-3', type: 'user', content: 'Here are the workshop footage and product photos.', sender: 'user', timestamp: hoursAgo(94), files: [{ name: 'workshop-footage.mp4', type: 'video', size: '156 MB' }, { name: 'product-photos-batch.zip', type: 'archive', size: '42 MB' }, { name: 'brand-guidelines.pdf', type: 'document', size: '3.8 MB' }] },
      { id: 'msg-3-4', type: 'status_update', content: 'Your project is now in production.', sender: 'system', timestamp: hoursAgo(72), newStatus: 'in_production' },
      { id: 'msg-3-5', type: 'team', content: "Roberto, we're in the final stages. The video is looking great - the fabric detail shots came out beautifully.", sender: 'Ana (Production)', timestamp: hoursAgo(12) }
    ]
  },
  {
    id: 'proj-4',
    name: 'Emotional Brand Story',
    client: { name: 'Carlos Mendoza', avatar: AVATARS[0] },
    brandId: null,
    status: 'received',
    videoType: 'Storytelling',
    duration: '2 minutes',
    style: 'Emotional, cinematic',
    description: "An emotional storytelling video about the brand's origin and mission.",
    createdAt: hoursAgo(3),
    deliveryDeadline: hoursFromNow(69),
    hasNewUpdate: true,
    qualityControl: null,
    delivery: null,
    internalNotes: '',
    messages: [
      { id: 'msg-4-1', type: 'system', content: 'Welcome to your new project! Tell us about the video you need.', sender: 'system', timestamp: hoursAgo(3) },
      { id: 'msg-4-2', type: 'user', content: "I want to create an emotional storytelling video about my journey as a chef and how La Boqueria was born. Something cinematic, 2 minutes, that makes people feel the passion behind our food.", sender: 'user', timestamp: hoursAgo(2.5) },
      { id: 'msg-4-3', type: 'user', content: "Here's a voice recording I made telling the story, and some old family photos.", sender: 'user', timestamp: hoursAgo(2), files: [{ name: 'my-story-voiceover.mp3', type: 'audio', size: '8.4 MB' }, { name: 'family-photos-collection.zip', type: 'archive', size: '22 MB' }] }
    ]
  },
  {
    id: 'proj-5',
    name: 'Summer Collection Reel',
    client: { name: 'Sofia Rivera', avatar: AVATARS[1] },
    brandId: 'brand-2',
    status: 'ready',
    videoType: 'Social Media Reel',
    duration: '30 seconds',
    style: 'Fast-paced, trendy, vibrant',
    description: 'A short, fast-paced reel for Instagram showcasing the summer collection highlights.',
    createdAt: hoursAgo(168),
    deliveryDeadline: hoursAgo(24),
    hasNewUpdate: true,
    revisionCount: 0,
    qualityControl: null,
    delivery: {
      thumbnail: VIDEO_THUMBNAILS[0],
      deliveredAt: hoursAgo(48),
      files: [
        { name: 'summer-reel-final.mp4', type: 'video', size: '45 MB' },
        { name: 'summer-reel-vertical.mp4', type: 'video', size: '38 MB' },
        { name: 'cover-thumbnail.png', type: 'image', size: '1.2 MB' }
      ]
    },
    internalNotes: 'Client loved the first draft. Only minor color adjustments needed.',
    messages: [
      { id: 'msg-5-1', type: 'system', content: 'Welcome to your new project! Tell us about the video you need.', sender: 'system', timestamp: hoursAgo(168) },
      { id: 'msg-5-2', type: 'user', content: "I need a quick Instagram reel for our summer collection. 30 seconds, fast-paced, trendy. Think TikTok energy but on-brand for MODA.", sender: 'user', timestamp: hoursAgo(167) },
      { id: 'msg-5-3', type: 'user', content: 'Product shots and model photos attached.', sender: 'user', timestamp: hoursAgo(166), files: [{ name: 'summer-products.zip', type: 'archive', size: '85 MB' }, { name: 'model-shots.zip', type: 'archive', size: '120 MB' }] },
      { id: 'msg-5-4', type: 'status_update', content: 'Your project is now in production.', sender: 'system', timestamp: hoursAgo(144), newStatus: 'in_production' },
      { id: 'msg-5-5', type: 'team', content: "Sofia, first draft is ready! The energy is exactly what we discussed.", sender: 'Marco (Director)', timestamp: hoursAgo(96) },
      { id: 'msg-5-7', type: 'status_update', content: 'Your video has been delivered.', sender: 'system', timestamp: hoursAgo(48), newStatus: 'delivered' },
      { id: 'msg-5-8', type: 'delivery', content: "Your video is ready! Here's the final delivery:", sender: 'system', timestamp: hoursAgo(48), delivery: { thumbnail: VIDEO_THUMBNAILS[0], files: [{ name: 'summer-reel-final.mp4', type: 'video', size: '45 MB' }, { name: 'summer-reel-vertical.mp4', type: 'video', size: '38 MB' }, { name: 'cover-thumbnail.png', type: 'image', size: '1.2 MB' }] } },
      { id: 'msg-5-9', type: 'user', content: 'This is perfect! Exactly what I had in mind. The energy is amazing. Thank you!', sender: 'user', timestamp: hoursAgo(47) }
    ]
  }
];

export const VIDEO_TYPES = ['Promotional', 'Lookbook / Fashion', 'Product Showcase', 'Storytelling', 'Social Media Reel', 'Corporate', 'Tutorial', 'Event Highlight'];
export const DURATIONS = ['15 seconds', '30 seconds', '45 seconds', '60 seconds', '90 seconds', '2 minutes', '3 minutes'];
export const STYLES = ['Cinematic', 'Modern & Clean', 'Fast-paced', 'Emotional', 'Documentary', 'Editorial', 'Minimalist', 'Bold & Dynamic'];
